module.exports = __webpack_public_path__ + "static/media/country_jp.c510a1d7.webp";